module.exports = __webpack_public_path__ + "static/lala-8c433e3ae83e699ef3f5b5f041d2299e.jpg";